import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

// import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import ConfigModule from "@/store/modules/ConfigModule";
import ThemeModeModule from "@/store/modules/ThemeModeModule";
import ExAuthModule from "@/exstore/ExAuthModule";

config.rawError = true;

const store = createStore({
  modules: {
    ExAuthModule,
    BodyModule,
    ConfigModule,
    ThemeModeModule,
  },
});

export default store;
